import { BOARD_LAYOUT } from './utils'

export type PlayerId = 1 | 2
export type BoardState = Record<number, PlayerId> // product -> playerId

export function checkWin(
  board: BoardState,
  lastProduct: number,
  player: PlayerId,
): boolean {
  // Find coordinates of the last move
  let row = -1,
    col = -1
  for (let r = 0; r < 6; r++) {
    for (let c = 0; c < 6; c++) {
      if (BOARD_LAYOUT[r][c] === lastProduct) {
        row = r
        col = c
        break
      }
    }
  }

  if (row === -1) return false

  const directions = [
    [0, 1], // Horizontal
    [1, 0], // Vertical
    [1, 1], // Diagonal \
    [1, -1], // Diagonal /
  ]

  for (const [dr, dc] of directions) {
    let count = 1 // Start with the placed chip

    // Check forward
    for (let i = 1; i < 4; i++) {
      const r = row + dr * i
      const c = col + dc * i
      if (r < 0 || r >= 6 || c < 0 || c >= 6) break
      const product = BOARD_LAYOUT[r][c]
      if (board[product] === player) count++
      else break
    }

    // Check backward
    for (let i = 1; i < 4; i++) {
      const r = row - dr * i
      const c = col - dc * i
      if (r < 0 || r >= 6 || c < 0 || c >= 6) break
      const product = BOARD_LAYOUT[r][c]
      if (board[product] === player) count++
      else break
    }

    if (count >= 4) return true
  }

  return false
}

export function getLegalMoves(
  board: BoardState,
  currentDials: { a: number; b: number },
): number[] {
  const legalProducts: number[] = []
  const { a, b } = currentDials

  // Case 1: Keep a, change b (1-9)
  for (let newB = 1; newB <= 9; newB++) {
    const p = a * newB
    if (!board[p]) legalProducts.push(p)
  }

  // Case 2: Keep b, change a (1-9)
  for (let newA = 1; newA <= 9; newA++) {
    const p = newA * b
    if (!board[p]) legalProducts.push(p)
  }

  return [...new Set(legalProducts)] // Unique products
}
